import { Button } from "@/components/ui/button";
import { useLanguage } from "@/components/language-provider";
import { Globe } from "lucide-react";

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage();
  
  const toggle = () => {
    setLanguage(language === "en" ? "pt" : "en");
  };
  
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggle}
      className="gap-1.5"
      data-testid="button-language-toggle"
    >
      <Globe className="h-4 w-4" />
      <span className="text-xs font-medium">{language.toUpperCase()}</span>
    </Button>
  );
}
